import getProp from '@f/get-prop'
import { getWorkspace } from './workspaces'

export const getApplicationSettings = (state, feature) => state.application[feature]
export const getActiveWorkspaceSlug = (state) => state.application.page.currentWorkspaceSlug
export const getCatalogDetailSettings = (state) => getApplicationSettings(state, 'catalog').detail
export const getCatalogOverviewSettings = (state) => getApplicationSettings(state, 'catalog').overview
export const getSourceUpgradeSettings = (state) => getApplicationSettings(state, 'sourceUpgrades')
export const getSourcesListSettings = (state) => getApplicationSettings(state, 'sourcesList')
export const getSetupSettings = (state) => getApplicationSettings(state, 'setup')
export const getActiveWorkspace = (state) => getWorkspace(state, getActiveWorkspaceSlug(state))
export const getAppSettings = (state) => getApplicationSettings(state, 'app')
export const getChurnSurvey = (state, surveyKey) => {
  const applicationSettings = getApplicationSettings(state, 'churnSurvey')
  return applicationSettings[surveyKey] || {}
}
export const getSourceIntegrationsSettings = (state) => getApplicationSettings(state, 'sourceIntegrations')

export const getRuleEditor = state => getProp('application.rules.editor', state)
export const isRulesWarningDialogOpen = state => getProp('application.rules.isWarningDialogOpen', state)
export const checkRulesOverviewModalState = state => getProp('application.rules.overview.isModalOpen', state)
export const getRulesOverviewActiveRule = state => getProp('application.rules.overview.activeRule', state)
export const getRulesOverviewActiveProject = state => getProp('application.rules.overview.activeProject', state)
export const getRulesLogSettings = (state) => getProp('application.rules.log', state)



// WEBPACK FOOTER //
// ./selectors/application.js